export const BUBBLE_MENU_OVERFLOW_PADDING = 20

export const BUBBLE_MENU_CONTENT_PADDING = 8

export const BUBBLE_MENU_MINIMUM_MAX_HEIGHT = 250
